import React from 'react';
import styled from 'styled-components';

const Input = styled.textarea`
 margin:${props => props.margin};
 border: 1px solid rgba(0,0,0,0.4);
 padding: ${props => props.padding};
 font-size: ${props => props.fontSize};
 font-family:inherit;
 width: ${props => props.width};
 height:${props => props.height};
 border-radius: 1rem;
 cursor: pointer;
 border-radius: 4px;
 box-shadow:${props => props.boxShadow};
 resize:${props => props.resize};
`;

Input.defaultProps = {
 padding: "1rem",
 fontSize: "1rem",
 width: "13em",
 boxShadow:'none',
 resize:"none"
}

//rgba(45, 35, 66, 0.2) 0 2px 4px,rgba(45, 35, 66, 0.15) 0 7px 13px -3px,#D6D6E7 0 -3px 0 inset

const Textarea = (props) => {

  return (
    <Input {...props} />
  )
}

export default Textarea;
